// Fixed, non-interactive ambient backdrop layered over the body's sky gradient:
// a rotating sun bleeding off the top-right, two parallax cloud bands, and
// (optionally) streaking speed lines. Purely decorative — animations pause
// automatically under prefers-reduced-motion (see index.css).

export default function SceneBackground({ showSpeed = true }: { showSpeed?: boolean }) {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden>
      {/* sun */}
      <div
        className="absolute h-[280px] w-[280px] rounded-full"
        style={{
          top: "-70px",
          right: "-70px",
          background:
            "radial-gradient(circle at 50% 50%, #fff3b0 0%, #ffd23f 55%, #ffb627 100%)",
          boxShadow:
            "0 0 0 18px rgba(255,210,63,.25), 0 0 0 40px rgba(255,210,63,.12)",
        }}
      />
      <div className="animate-sun absolute" style={{ top: "60px", right: "60px", width: "160px", height: "160px" }}>
        <div className="absolute left-1/2 top-1/2 h-3.5 w-[230px] rounded-lg" style={{ background: "rgba(255,255,255,.45)", transform: "translate(-50%,-50%) rotate(0deg)" }} />
        <div className="absolute left-1/2 top-1/2 h-3.5 w-[230px] rounded-lg" style={{ background: "rgba(255,255,255,.35)", transform: "translate(-50%,-50%) rotate(60deg)" }} />
        <div className="absolute left-1/2 top-1/2 h-3.5 w-[230px] rounded-lg" style={{ background: "rgba(255,255,255,.45)", transform: "translate(-50%,-50%) rotate(120deg)" }} />
      </div>

      {/* clouds — back layer */}
      <div className="animate-clouds-back absolute left-0 top-[120px] h-[120px] w-[200%]">
        <div className="absolute h-[60px] w-[160px] rounded-[40px] bg-white/70" style={{ left: "120px", top: "30px" }} />
        <div className="absolute h-[70px] w-[90px] rounded-full bg-white/70" style={{ left: "180px", top: "8px" }} />
        <div className="absolute h-[54px] w-[140px] rounded-[40px] bg-white/60" style={{ left: "620px", top: "40px" }} />
        <div className="absolute h-[50px] w-[120px] rounded-[40px] bg-white/[.65]" style={{ left: "980px", top: "20px" }} />
        <div className="absolute h-[54px] w-[150px] rounded-[40px] bg-white/60" style={{ left: "1480px", top: "30px" }} />
      </div>
      {/* clouds — front layer */}
      <div className="animate-clouds absolute left-0 top-[60px] h-[160px] w-[200%]">
        <div className="absolute h-[80px] w-[210px] rounded-[50px] bg-white" style={{ left: "60px", top: "30px" }} />
        <div className="absolute h-[96px] w-[120px] rounded-full bg-white" style={{ left: "130px", top: "-4px" }} />
        <div className="absolute h-[72px] w-[180px] rounded-[50px] bg-white" style={{ left: "760px", top: "40px" }} />
        <div className="absolute h-[84px] w-[96px] rounded-full bg-white" style={{ left: "820px", top: "8px" }} />
        <div className="absolute h-[72px] w-[180px] rounded-[50px] bg-white" style={{ left: "1360px", top: "36px" }} />
      </div>

      {/* speed lines */}
      {showSpeed && (
        <div className="absolute inset-0">
          <div className="animate-speed absolute right-0 h-3 w-[220px] rounded-lg bg-white opacity-0" style={{ top: "26%", animationDuration: "1.8s" }} />
          <div className="animate-speed absolute right-0 h-3.5 w-[300px] rounded-lg bg-white opacity-0" style={{ top: "40%", animationDelay: ".4s", animationDuration: "1.5s" }} />
          <div className="animate-speed absolute right-0 h-2.5 w-[180px] rounded-lg bg-white opacity-0" style={{ top: "58%", animationDelay: ".9s", animationDuration: "2.1s" }} />
          <div className="animate-speed absolute right-0 h-3 w-[260px] rounded-lg bg-white opacity-0" style={{ top: "70%", animationDelay: ".2s", animationDuration: "1.7s" }} />
        </div>
      )}
    </div>
  );
}
